import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon } from 'lucide-react';
export function CTASection({
  onAddToCart
}: {
  onAddToCart?: () => void;
}) {
  return <section className="bg-forest py-16 md:py-24" aria-labelledby="final-cta-heading" data-id="element-186">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-188">
          <h2 id="final-cta-heading" className="font-serif text-cream text-3xl md:text-4xl lg:text-5xl font-700 italic leading-tight mb-6" data-id="element-189">
            Your Body Isn't Broken. It's Been Getting the Wrong Signal.
          </h2>

          <p className="font-sans text-sage text-lg leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-190">
            You don't need more willpower. You don't need another diet. You need
            to change what your kitchen is telling your brain. The Thermal
            Window Protocol does exactly that — in 21 days, with real food, at a
            price that's less than a single doctor's visit.
          </p>

          <a href="https://buenavibrax.com/cart/45502602674233:1" onClick={e => {
          if (onAddToCart) {
            e.preventDefault();
            onAddToCart();
          }
        }} className="inline-block bg-terracotta hover:bg-terracotta/90 text-white font-sans font-700 text-xl px-10 py-5 rounded-xl transition-all duration-200 shadow-xl hover:shadow-2xl hover:-translate-y-1 mb-6" aria-label="Start your 21-day cortisol reset for $27" data-id="element-191">
            Start My 21-Day Cortisol Reset — $6.36
          </a>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sage/80 text-sm font-sans mb-16" data-id="element-192">
            <span className="flex items-center gap-1.5" data-id="element-193">
              <ShieldCheckIcon className="w-4 h-4" aria-hidden="true" data-id="element-194" />
              60-Day Money-Back Guarantee
            </span>
            <span className="flex items-center gap-1.5" data-id="element-195">
              <DownloadIcon className="w-4 h-4" aria-hidden="true" data-id="element-196" />
              Instant Digital Access
            </span>
            <span data-id="element-197">No Subscriptions Ever</span>
          </div>
        </motion.div>

        {/* Footer */}
        <motion.footer initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="border-t border-white/10 pt-8" data-id="element-198">
          <p className="font-sans text-sage/60 text-xs leading-relaxed" data-id="element-199">
            © 2025 The Cortisol Reset Kitchen. All Rights Reserved.
            <br data-id="element-200" />
            This product is not intended to diagnose, treat, cure, or prevent
            any disease.
          </p>
        </motion.footer>
      </div>
    </section>;
}